/*eslint-disable*/
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

// @mui/material components
import { makeStyles } from '@mui/styles';

// material ui icons
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import ParametersIcon from '@mui/icons-material/FormatListBulleted';

// core components
import CustomInput from 'components/CustomInput/CustomInput.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';
import DatePicker from 'components/CustomInput/CalendarInput.js';
import TemplateSelector from './TemplateSelector';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/parameterSetEditStyle.js';

// Redux
import Icon from '@mui/material/Icon';
import { selectViewIsDirty, setViewIsDirty } from 'features/ux/uxSlice';

import TemplateEditor from './TemplateEditor';
import { Box, Typography } from '@mui/material';
import { useGetClientTemplateDictionaryQuery } from 'api/parameter.api';
import { useUpdateTemplateSetMutation } from 'api/parameter.api';
import { useAddTemplateSetMutation } from 'api/parameter.api';
import { toast } from 'react-toastify';

const useStyles = makeStyles(styles);
let pendingRedirectUrl = null;

const getEmptyParameterSet = () => {
  return {
    name: '',
    description: '',
    temporary: false,
    start_date: '',
    end_date: '',
    parameters: [],
  };
};

export default function TemplateSet(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const viewIsDirty = useSelector(selectViewIsDirty);
  const {data: templateDictionary} = useGetClientTemplateDictionaryQuery();
  const [updateTemplateSet] = useUpdateTemplateSetMutation();
  const [addTemplateSet] = useAddTemplateSetMutation();

  const newParameterSet = location.state?.new ?? false;
  const parameterSet = newParameterSet
    ? getEmptyParameterSet()
    : location.state.parameterSet;
  const [parameters, setParameters] = useState(parameterSet.parameters);

  const [version, setVersion] = useState(parameterSet.version);
  const [name, setName] = useState(parameterSet.name);
  const [nameState, setNameState] = useState('');
  const [nameError, setNameError] = useState('');
  const [description, setDescription] = useState(parameterSet.description);
  const [descriptionState, setDescriptionState] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [temporary, setTemporary] = useState(parameterSet.temporary);
  const [temporaryState, setTemporaryState] = useState('');
  const [temporaryError, setTemporaryError] = useState('');
  const [startDate, setStartDate] = useState(
    parameterSet.start_date ? parameterSet.start_date : ''
  );
  const [startDateState, setStartDateState] = useState('');
  const [startDateError, setStartDateError] = useState('');
  const [endDate, setEndDate] = useState(parameterSet.end_date);
  const [endDateState, setEndDateState] = useState('');
  const [endDateError, setEndDateError] = useState('');
  
  const [showEditorModal, setShowEditorModal] = useState(false);
  const [currentEditingTemplate, setCurrentEditingTemplate] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [errorTemplatesCount, setErrorTemplatesCount] = useState('');
  
  const [hasAddedItem, setHasAddedItem] = useState(false);
  const [currentParameterIndex, setCurrentParameterIndex] = React.useState();
  const [data, setData] = React.useState([]);
  
  // function that verifies if a string has a given length or not
  const verifyLength = (value, original, length, required = true) => {
    if (value && value.length >= length) {
      if (value !== original) dispatch(setViewIsDirty(true));
      return true;
    } else if (!required && (!value || value.length === 0)) {
      if (value !== original) dispatch(setViewIsDirty(true));
      return true;
    }
    return false;
  };

  const isEndDateValid = function (current) {
    const start = moment(startDate);
    if (startDate) return current.isAfter(start);
    else return true;
  };
  const isStartDateValid = function (current) {
    const end = moment(endDate);
    if (endDate) return current.isBefore(end);
    else return true;
  };

  const getDateFromPickerEvent = (event) => {
    if (event?._isAMomentObject && typeof event.toDate === 'function') {
      const date = event.toDate();
      return Number.isNaN(date.getTime()) ? null : date;
    }

    if (typeof event === 'string') {
      if (event.trim() === '') {
        return '';
      }

      return null;
    }

    if (event instanceof Date) {
      return Number.isNaN(event.getTime()) ? null : event;
    }

    return null;
  };

  const changeClick = async () => {
    if (viewIsDirty && data?.length === 0) {
      setErrorTemplatesCount(
        'You must add at least one template to save this template set'
      );
      return;
    }
    var error = false;
    var updatedSet = cloneDeep(parameterSet);

    if (!verifyLength(name, name, 3)) {
      error = true;
      setNameState('error');
    }
    if (!verifyLength(description, description, 3)) {
      error = true;
      setDescriptionState('error');
    }
    if (error === false) {
      const isTemporary = !!(endDate && endDate !== '');

      updatedSet.name = name;
      updatedSet.description = description;
      updatedSet.temporary = isTemporary;
      updatedSet.type = 'template';
      updatedSet.start_date =
        startDate && startDate !== '' ? startDate : null;
      updatedSet.end_date = endDate && endDate !== '' ? endDate : null;
      // the parameter array and the data array are in-sync, so move value and immutable flag over to updated parameter set
      updatedSet.parameters = data.map((entry, index) => {
        return {
          name: entry.parameter.name,
          type: entry.type,
          value: entry.value,
          immutable:
          entry.immutable === true ||
          entry.immutable === 'true' ||
          entry.immutable === 'True',
        };
      });

      try {
        if (newParameterSet) {
          await addTemplateSet(updatedSet).unwrap();
        } else {
          await updateTemplateSet(updatedSet).unwrap();
        }

        pendingRedirectUrl = '/admin/templatesets';
        dispatch(setViewIsDirty(false));
      } catch (err) {
        const errors = err?.data?.errors;
        const errorMessage =
          (Array.isArray(errors) && errors.length ? Object.values(errors[0])[0] : null) ||
          err?.data?.message ||
          'An error occurred while trying to save the template set';

        toast.error(errorMessage, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    }
  };
  

  const handleEditTemplate = (index) => {
    setEditIndex(index);
  };

  useEffect(() => {
    if (editIndex !== null && data[editIndex]) {
      const dataEntry = data[editIndex];
      const dictionaryEntry = templateDictionary.find(
        (entry) => entry.name === dataEntry.parameter.name
      );
      const template = {
        ...dictionaryEntry,
        value: dataEntry.value,
        immutable: dataEntry.immutable,
        isNew: dataEntry?.isNew ?? false,
      };
      setCurrentEditingTemplate(template);
      setShowEditorModal(true);
    }
  }, [editIndex, data]);

  const getData = () =>
    parameters
      .map((parameter, key) => {
        const entry = templateDictionary.find(
          (el) => el?.name === parameter?.name
        );
        if (!entry) {
          return;
        }
        return {
          id: key,
          category: entry?.category || 'No category',
          parameter: {
            name: entry.name || 'No name',
            description: entry.description,
          },
          value: parameter.value,
          type: entry.type,
          immutable: parameter.immutable === true ? 'True' : 'False',
          actions: (
            <div className='actions-left'>
              <Button
                justIcon
                round
                simple
                onClick={() => handleEditTemplate(key)}
                color='warning'
                className='edit'
              >
                <Edit />
              </Button>
              <Button
                justIcon
                round
                simple
                onClick={() => handleDeleteParameter(key)}
                color='warning'
                className='edit'
              >
                <Delete />
              </Button>
            </div>
          ),
        };
      })
      .filter(Boolean);


  useEffect(() => {
    if (data.length === 0 && parameters.length !== 0) {
      setData(getData());
    }
  }, [data]);

  const formatParameterCell = ({ value }) => {
    return (
      <div>
        <span className={classes.parameterName}>{value.name}</span>
        <span className={classes.parameterDescription}>
          {value.description}
        </span>
      </div>
    );
  };

  const [selectParameters, setSelectParameters] = React.useState(false);
  const addParameterHandler = () => {
    setSelectParameters(true);
  };

  const handleCloseTemplateSelector = () => {
    setSelectParameters(false);
  };

  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const handleDeleteParameter = (index) => {
    setCurrentParameterIndex(index);
    setConfirmDelete(true);
  };

  const deleteParameter = () => {
    data.splice(currentParameterIndex, 1); // remove entry
    // renumber data entries
    const newData = data.map((parameter, key) => {
      const parameterRow = {
        id: key,
        category: parameter?.category || 'No category',
        parameter: parameter.parameter,
        value: parameter.value,
        type: parameter.type,
        immutable: parameter.immutable,
        actions: (
          <div className='actions-left'>
            <Button
              justIcon
              round
              simple
              onClick={() => handleEditTemplate(key)}
              color='warning'
              className='edit'
            >
              <Edit />
            </Button>
            <Button
              justIcon
              round
              simple
              onClick={() => handleDeleteParameter(key)}
              color='warning'
              className='edit'
            >
              <Delete />
            </Button>
          </div>
        ),
      };
      return parameterRow;
    });
    setData(newData);
    setParameters(newData);
    dispatch(setViewIsDirty(true));
    setConfirmDelete(false);
  };

  const handleAddParameters = async (parameters) => {
    let newData = [...data];
    let offset = newData.length;
    for (let i = 0; i < parameters.length; i++) {
      const parameter = parameters[i];
      const newParameter = {
        id: parameter.key + offset,
        category: parameter?.category || 'No category',
        parameter: {
          name: parameter.name || 'No name',
          description: parameter.description,
        },
        value: parameter.default,
        type: parameter.type,
        immutable: 'False',
        isNew: true,
        changed: 'No',
        actions: (
          <div className='actions-left'>
            <Button
              justIcon
              round
              simple
              onClick={() => handleEditTemplate(parameter.key + offset)}
              color='warning'
              className='edit'
            >
              <Edit />
            </Button>
            <Button
              justIcon
              round
              simple
              onClick={() => handleDeleteParameter(parameter.key + offset)}
              color='warning'
              className='edit'
            >
              <Delete />
            </Button>
          </div>
        ),
      };
      newData.push(newParameter);
    }
    setData(newData);
    dispatch(setViewIsDirty(true));
    setHasAddedItem(true);
  };

  const editableTemplate = () => {
    const dataEntry = data[currentParameterIndex];
    const dictionaryEntry = templateDictionary.find(
      (entry) => entry.name === dataEntry.parameter.name
    );
    return {
      ...dictionaryEntry,
      value: dataEntry.value,
      immutable: dataEntry.immutable,
    };
  };

  useEffect(() => {
    dispatch(setViewIsDirty(false));
  }, []);

  useEffect(() => {
    if (pendingRedirectUrl) {
      props.history.push(pendingRedirectUrl);
      pendingRedirectUrl = null;
    }
  }, [viewIsDirty]);

  useEffect(() => {
    if (data.length === 0 && viewIsDirty && hasAddedItem) {
      setErrorTemplatesCount(
        'You must add at least one template to save this template set'
      );
    } else {
      setErrorTemplatesCount('');
    }
  }, [data, viewIsDirty, hasAddedItem]);

  const updateTemplateValue = (updatedValue) => {
    if (!currentEditingTemplate) {
      console.error('currentEditingTemplate is undefined');
      return;
    }
    const updatedData = data.map((item) => {
      if (item.parameter.name === currentEditingTemplate['name']) {
        return { ...item, value: updatedValue };
      }
      return item;
    });
    setData(updatedData);
    dispatch(setViewIsDirty(true));
  };

  const handleCloseEditorModal = (updatedValue = null) => {
    if (updatedValue) {
      updateTemplateValue(updatedValue);
    }
    setShowEditorModal(false);
    setCurrentEditingTemplate(null);
    setEditIndex(null);
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color='primary' icon>
              <CardIcon color='primary'>
                <ParametersIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Template Set</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <CustomInput
                    helperText={
                      nameState === 'error'
                        ? nameError ?? 'An error has occurred'
                        : false
                    }
                    success={nameState === 'success'}
                    error={nameState === 'error'}
                    labelText='Template Set Name'
                    id='name'
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      defaultValue: name,
                      onChange: (event) => {
                        if (verifyLength(event.target.value, name, 3)) {
                          setNameState('success');
                          setNameError('');
                        } else {
                          setNameState('error');
                          setNameError(
                            'Field must contain at least 3 alphanumeric or special characters'
                          );
                        }
                        setName(event.target.value);
                      },
                      autoComplete: 'off',
                    }}
                  />
                  <CustomInput
                    helperText={
                      descriptionState === 'error'
                        ? descriptionError ?? 'An error has occurred'
                        : false
                    }
                    success={descriptionState === 'success'}
                    error={descriptionState === 'error'}
                    labelText='Template Set Description'
                    id='description'
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      defaultValue: description,
                      onChange: (event) => {
                        if (verifyLength(event.target.value, description, 3)) {
                          setDescriptionState('success');
                          setDescriptionError('');
                        } else {
                          setDescriptionState('error');
                          setDescriptionError(
                            'Field must contain at least 3 alphanumeric or special characters'
                          );
                        }
                        setDescription(event.target.value);
                      },
                      autoComplete: 'off',
                    }}
                  />
                  <DatePicker
                    isValidDate={(current) => {
                      return endDate ? current.isBefore(endDate) : true;
                    }}
                    success={startDateState === 'success'}
                    error={startDateState === 'error'}
                    labelText='Start Date'
                    id='startdate'
                    formControlProps={{
                      fullWidth: true,
                    }}
                    validator={isStartDateValid}
                    inputProps={{
                      value: startDate
                        ? new Date(startDate).toDateString()
                        : '',
                      onChange: (event) => {
                        const nextStartDate = getDateFromPickerEvent(event);
                        if (nextStartDate === null) {
                          return;
                        }

                        dispatch(setViewIsDirty(true));
                        setStartDateState(nextStartDate === '' ? '' : 'success');
                        setStartDate(nextStartDate);
                      },
                    }}
                  />
                  <DatePicker
                    isValidDate={(current) => {
                      return startDate ? current.isAfter(startDate) : true;
                    }}
                    success={endDateState === 'success'}
                    error={endDateState === 'error'}
                    labelText='End Date'
                    id='enddate'
                    formControlProps={{
                      fullWidth: true,
                    }}
                    validator={isEndDateValid}
                    inputProps={{
                      value: endDate ? new Date(endDate).toDateString() : '',
                      onChange: (event) => {
                        const nextEndDate = getDateFromPickerEvent(event);
                        if (nextEndDate === null) {
                          return;
                        }

                        dispatch(setViewIsDirty(true));
                        setEndDateState(nextEndDate === '' ? '' : 'success');
                        setEndDate(nextEndDate);
                        if (nextEndDate !== '') {
                          setTemporary(true);
                          setTemporaryState('success');
                        } else {
                          setTemporary(false);
                          setTemporaryState('');
                        }
                      },
                    }}
                  />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography className={classes.version}>Version {version}</Typography>
                    <Box>
                      <Button
                        color='primary'
                        onClick={changeClick}
                        className={classes.registerButton}
                        disabled={!viewIsDirty || !data.length}
                      >
                        Save Changes
                      </Button>
                      <Button
                        color='secondary'
                        onClick={() => history.push('/admin/templatesets')}
                        className={classes.registerButton}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color='primary' icon>
              <CardIcon color='primary'>
                <ParametersIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Templates</h4>
              {errorTemplatesCount && (
                <div className={classes.errListTemplatesMsg}>
                  <Icon>info</Icon> {errorTemplatesCount}
                </div>
              )}
              <Button
                color='primary'
                onClick={addParameterHandler}
                className={classes.registerButton}
              >
                + Add Template
              </Button>
            </CardHeader>
            <CardBody>
              <ReactTable
                columns={[
                  {
                    Header: 'Template',
                    accessor: 'parameter',
                    Cell: formatParameterCell,
                    filter: 'parameter',
                    disableSortBy: true,
                    width: 200,
                  },
                  {
                    Header: 'Immutable?',
                    accessor: 'immutable',
                    disableFilters: true,
                    disableSortBy: true,
                    width: 50,
                    style: {
                      marginBottom: 40,
                      width: '10%',
                    },
                  },
                  {
                    Header: 'Actions',
                    accessor: 'actions',
                    disableFilters: true,
                    disableSortBy: true,
                    width: 50,
                    style: {
                      marginTop: 0,
                      width: '10%',
                    },
                  },
                ]}
                data={[...data].sort((a, b) => a.parameter.name.localeCompare(b.parameter.name))}
                options={{
                  pageSize: data?.length,
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
        {selectParameters === true ? (
          <TemplateSelector
            open={selectParameters}
            handleClose={handleCloseTemplateSelector}
            handleAdd={handleAddParameters}
            dictionary={templateDictionary?.filter(
              (p) => !data.find((d) => d.parameter.name === p.name)
            )}
          />
        ) : null}
      </GridContainer>
      <Dialog
        open={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Delete{' '}
          {data[currentParameterIndex]
            ? data[currentParameterIndex].parameter.name
            : ''}
          ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to remove this parameter?
            <br />
            Press Delete to confirm, or Cancel to cancel.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemedSecondaryBtn onClick={() => setConfirmDelete(false)}>
            Cancel
          </ThemedSecondaryBtn>
          <ThemedPrimaryBtn
            onClick={() => deleteParameter()}
            color='primary'
            autoFocus
          >
            Delete
          </ThemedPrimaryBtn>
        </DialogActions>
      </Dialog>

      {/* Dialog to avoid moving to another path and be able to edit the template in the same view */}
      <Dialog
        open={showEditorModal}
        onClose={handleCloseEditorModal}
        maxWidth='md'
        fullWidth
      >
        {currentEditingTemplate && (
          <TemplateEditor
            template={currentEditingTemplate}
            isNewTemplate={currentEditingTemplate?.isNew ?? false}
            onDialogClose={handleCloseEditorModal}
            isDialogMode={true}
            parameterSet={parameterSet}
            tenantTemplate={true}
            closeModal={handleCloseEditorModal}
          />
        )}
      </Dialog>
    </>
  );
}
